import React, { useState, useRef, useEffect } from 'react';
import ReactApexChart from 'react-apexcharts';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import { fetchData } from '@utils/functions';
import { useSelector } from "react-redux";

 
 
const FamilySizeChart = () => {
  const familySizeFilter = useSelector(state => state.dashboard?.familySizeCount);

  const [showModal, setShowModal] = useState(false);
  const chartRef = useRef(null);
  const modalChartRef = useRef(null);
 
 
  const series = [
    {
      name: 'HH %',
      data: familySizeFilter.map(item => item.count),
    }
  ];
  const options = {
    chart: {
      type: 'bar',
      height: '100%',
      toolbar: { show: false }
    },
    plotOptions: {
      bar: {
        horizontal: true,
        barHeight: '50%',
        distributed: true
      }
    },
    fill: {
      type: 'gradient',
      gradient: {
        shade: 'light',
        type: 'horizontal',
        shadeIntensity: 0.6,
        gradientToColors: ['#000428'],
        inverseColors: false,
        opacityFrom: 0.9,
        opacityTo: 1,
        stops: [0, 100]
      }
    },
    colors: ['#004e92'],
    dataLabels: {
      enabled: true,
      formatter: (val) => `${val}`,
      style: {
        colors: ['#fff']
      }
    },
    xaxis: {
      categories: familySizeFilter.map(item => item.group),
      labels: {
        style: {
          fontSize: '12px'
        }
      }
    },
    yaxis: {
      labels: {
        style: {
          fontSize: '12px'
        }
      }
    },
    grid: {
      show: true,
      borderColor: ''
    },
    tooltip: {
      enabled: true,
      y: {
        formatter: (val) => `${val}%`
      }
    }
  };
 
  const exportChartAsPDF = async (isModal = false) => {
    const chartElement = isModal
      ? document.getElementById('modal-chart-container')
      : document.getElementById('chart-container');
 
    if (!chartElement) return;
 
    const canvas = await html2canvas(chartElement, {
      scale: 2,
      useCORS: true
    });
 
    const imgData = canvas.toDataURL('image/png');
    const pdf = new jsPDF('landscape', 'pt', 'a4');
    const pdfWidth = pdf.internal.pageSize.getWidth();
    const pdfHeight = (canvas.height * pdfWidth) / canvas.width;
 
    pdf.addImage(imgData, 'PNG', 0, 40, pdfWidth, pdfHeight);
    pdf.save('family-size-chart.pdf');
  };
 
  return (
    <>
      <div className="bg-white rounded-lg shadow-md flex flex-col h-full w-full">
        <div className="border-b px-4 py-3 rounded-t-lg gradiant2 flex justify-between items-center">
          <h3 className="text-[0.875rem] tracking-[0.0625rem] text-[#856800] font-bold uppercase">
            Family Size Group
          </h3>
        </div>
 
        <div
          className="cursor-pointer p-4"
          onClick={() => setShowModal(true)}
          title="Click to view fullscreen"
        >
          <div id="chart-container">
 
            <ReactApexChart
              ref={chartRef}
              options={options}
              series={series}
              type="bar"
              height={470}
            />
 
          </div>
        </div>
      </div>
 
      {showModal && (
        <div className="fixed inset-0 z-[9999] bg-white flex flex-col items-center justify-center">
          <button
            className="absolute top-4 left-6 text-3xl font-bold text-gray-600 hover:text-black"
            onClick={() => setShowModal(false)}
          >
            ×
          </button>
 
          <div className="absolute top-4 right-6">
            <div className="relative inline-block text-left">
              <div className="origin-top-right absolute right-0 mt-2 w-40 gradiant2 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 focus:outline-none z-50">
                <div className="py-1">
                  <button
                    onClick={() => exportChartAsPDF(true)}
                    className="w-full px-4 py-2 text-sm text-[#856800] font-bold"
                  >
                    Export PDF
                  </button>
                </div>
              </div>
            </div>
          </div>
 
          <h2 className="text-xl font-semibold text-[#856800]">
            Family Size Group
          </h2>
 
          <div id="modal-chart-container" className="w-[90vw] h-[80vh]">
            {familySizeFilter?.length > 0 && (
              <ReactApexChart
                ref={modalChartRef}
                options={options}
                series={series}
                type="bar"
                height="100%"
                width="100%"
              />
            )}
          </div>
        </div>
      )}
    </>
  );
};
 

export default FamilySizeChart;
